// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let DevicePixelRatio = require("../v5/common/DevicePixelRatio.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_response_removeAgentMarketingProfileFeaturedPhoto(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "AgentMarketingProfileFeaturedPhotoRemoved",
    "ProfileSettingsChangedError"
  ]);
}

let variablesConverter = {};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"removeAgentMarketingProfileFeaturedPhoto_AgentMarketingProfileFeaturedPhotoRemoved_marketingProfile":{"f":""},"removeAgentMarketingProfileFeaturedPhoto":{"u":"response_removeAgentMarketingProfileFeaturedPhoto"}}};

let wrapResponseConverterMap = {
  response_removeAgentMarketingProfileFeaturedPhoto: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

let responseConverter = {"__root":{"removeAgentMarketingProfileFeaturedPhoto_AgentMarketingProfileFeaturedPhotoRemoved_marketingProfile":{"f":""},"removeAgentMarketingProfileFeaturedPhoto":{"u":"response_removeAgentMarketingProfileFeaturedPhoto"}}};

let responseConverterMap = {
  response_removeAgentMarketingProfileFeaturedPhoto: unwrap_response_removeAgentMarketingProfileFeaturedPhoto
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

let Utils = {};

let providedVariablesDefinition = {
  __relay_internal__pv__DevicePixelRatio: {
    providedVariable: DevicePixelRatio.get,
    get: DevicePixelRatio.get
  }
};

function makeNode(providedVariablesDefinition) {
  return ((function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "settingsChangedMessage",
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "ProfileSettingsChangedError",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AgentMarketingProfileFeaturedPortraitForm_RemoveMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "removeAgentMarketingProfileFeaturedPhoto",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AgentMarketingProfile",
                "kind": "LinkedField",
                "name": "marketingProfile",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "AgentMarketingProfileFeaturedPortraitForm_agentMarketingProfile"
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "AgentMarketingProfileFeaturedPhotoRemoved",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__DevicePixelRatio"
      }
    ],
    "kind": "Operation",
    "name": "AgentMarketingProfileFeaturedPortraitForm_RemoveMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "removeAgentMarketingProfileFeaturedPhoto",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AgentMarketingProfile",
                "kind": "LinkedField",
                "name": "marketingProfile",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Image",
                    "kind": "LinkedField",
                    "name": "featuredPhoto",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "ratio",
                            "variableName": "__relay_internal__pv__DevicePixelRatio"
                          },
                          {
                            "kind": "Literal",
                            "name": "width",
                            "value": 400
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "url",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "height",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "width",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "nodeId",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "AgentMarketingProfileFeaturedPhotoRemoved",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "cec3b74e01d38bb9f7ed57019913d038",
    "id": null,
    "metadata": {},
    "name": "AgentMarketingProfileFeaturedPortraitForm_RemoveMutation",
    "operationKind": "mutation",
    "text": "mutation AgentMarketingProfileFeaturedPortraitForm_RemoveMutation(\n  $__relay_internal__pv__DevicePixelRatio: Float!\n) {\n  removeAgentMarketingProfileFeaturedPhoto {\n    __typename\n    ... on ProfileSettingsChangedError {\n      settingsChangedMessage: message\n    }\n    ... on AgentMarketingProfileFeaturedPhotoRemoved {\n      marketingProfile {\n        ...AgentMarketingProfileFeaturedPortraitForm_agentMarketingProfile\n        nodeId\n      }\n    }\n  }\n}\n\nfragment AgentMarketingProfileFeaturedPortraitForm_agentMarketingProfile on AgentMarketingProfile {\n  featuredPhoto {\n    url(width: 400, ratio: $__relay_internal__pv__DevicePixelRatio)\n    height\n    width\n  }\n}\n",
    "providedVariables": providedVariablesDefinition
  }
};
})());
}

let node = makeNode(providedVariablesDefinition);

let wrap_response_removeAgentMarketingProfileFeaturedPhoto = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_removeAgentMarketingProfileFeaturedPhoto = unwrap_response_removeAgentMarketingProfileFeaturedPhoto;
exports.wrap_response_removeAgentMarketingProfileFeaturedPhoto = wrap_response_removeAgentMarketingProfileFeaturedPhoto;
exports.Internal = Internal;
exports.Utils = Utils;
exports.providedVariablesDefinition = providedVariablesDefinition;
exports.node = node;
/* node Not a pure module */
